import { MdStar as IconStar } from "react-icons/md";
import { useQuery, gql } from "@apollo/client";
import Loader from "../../../components/Atoms/Loader";

interface Props {
  guideId: string;
}

export default function GuideStats({ guideId }: Props) {
  const { loading, error, data } = useQuery(GET_GUIDE_REVIEW_COUNT, {
    fetchPolicy: "cache-and-network",
    variables: {
      id: guideId,
    },
  });

  if (loading) {
    return <Loader />;
  }
  if (error || !data || !data.guide) {
    return "";
  }
  const { reviews } = data.guide;
  const { avgStars, totalRecords } = reviews;
  const roundedRating = (Math.round(avgStars * 10) / 10).toFixed(1);

  return (
    <div>
      {avgStars > 0 ? (
        <span>
          {roundedRating}{" "}
          <IconStar
            size={20}
            color="#F3E53A"
            style={{ position: "relative", top: 3 }}
          />
        </span>
      ) : null}
      {totalRecords > 0 ? (
        <span style={{ marginLeft: 12 }}>{totalRecords} reviews</span>
      ) : null}
    </div>
  );
}

const GET_GUIDE_REVIEW_COUNT = gql`
  query GuideProfileQuery($id: ID!) {
    guide(id: $id) {
      id
      reviews {
        avgStars
        totalRecords
      }
    }
  }
`;
